/** @jsxImportSource @emotion/react */
import { CSVLink } from "react-csv";
import { baseButtonStyle } from "./NewButtons";
import { css } from "@emotion/react";
import { effects } from "./effects";
import { colors } from "./colors";
import { StyledText } from "../assets/typography/typography";

type Props = {
  data?: Record<string, any>[];
  width?: string;
  height?: string;
  fileName: string;
  children: React.ReactNode;
};

export const DownloadAsCSVButton = ({
  data,
  width,
  height,
  fileName,
  children,
}: Props) => {
  const csvLinkStyle = css`
    ${baseButtonStyle}
    cursor: pointer;
    text-decoration: none !important;
    box-shadow: ${effects.buttonPrimary};
    background: ${colors.buttonPrimaryWhite};
    color: ${colors.textPrimary};
    width: ${width || "max-content"};
    height: ${height || "fit-content"};
    min-height: ${height || "fit-content"};
    min-width: ${width || "max-content"};
    &:hover {
      background: ${colors.whiteHover};
    }
  `;

  // We need to flatten the object in order to be able to download nested object values
  // Function taken from here: https://stackoverflow.com/questions/44134212/best-way-to-flatten-js-object-keys-and-values-to-a-single-depth-array
  const flattenObject = (data: Record<string, any>) => {
    var toReturn: Record<string, string | number> = {};

    for (const item in data) {
      if (!data.hasOwnProperty(item)) continue;

      if (typeof data[item] == "object" && data[item] !== null) {
        var flatObject = flattenObject(data[item]);
        for (var x in flatObject) {
          if (!flatObject.hasOwnProperty(x)) continue;

          toReturn[item + "." + x] = flatObject[x];
        }
      } else {
        // Replacing new lines with empty string
        const itemValue =
          typeof data[item] == "string"
            ? data[item].replace(/(\n)/gm, "")
            : data[item];
        toReturn[item] = itemValue;
      }
    }
    return toReturn;
  };

  return (
    <CSVLink
      css={csvLinkStyle}
      filename={fileName}
      data={(data || []).map((dataItem) => flattenObject(dataItem))}
    >
      <StyledText color={colors.textPrimary} className="bodyTextSemibold mb-0">
        {children}
      </StyledText>
    </CSVLink>
  );
};
